/**
 * Section Verify issue kinds in the words drafters use. The kinds are
 * the backend's (spec_schemas._SECTION_VERIFY_ISSUE_KINDS); one this
 * map does not know is shown with its underscores as spaces.
 */
const LABELS: Record<string, string> = {
  antecedent: 'Antecedent basis',
  missing_numeral_def: 'Undefined reference sign',
  claim_feature_uncovered: 'Claim feature not supported',
  redundant_text: 'Repeated text',
  tone_mismatch: 'Tone',
  // NB-17 — a statement the disclosure does not support or contradicts.
  unsupported_statement: 'Not in the disclosure',
  // NB-29 — a figure cited for a reference numeral it does not show.
  figure_mismatch: 'Figure does not show this',
};

export function verifyIssueKindLabel(kind: string): string {
  if (LABELS[kind]) return LABELS[kind];
  const words = (kind || '').replace(/_/g, ' ').trim();
  return words ? words[0].toUpperCase() + words.slice(1) : 'Issue';
}
